import gql from 'graphql-tag';

export const submitServiceRequestFeedbackMutation = gql(`
  mutation submitServiceRequestFeedbackMutation(
    $feedback: ServiceRequestFeedbackInput!
  ) {
    submitServiceRequestFeedback(feedback: $feedback) {
      success
      message
    }
  }
`);
